import { diContainer, serviceNames } from './service-setup/diContainer';

import { setupServiceInfo } from 'elc-universal-utils';

diContainer.get(serviceNames.productService).register();

setupServiceInfo(__serviceInfo__);
